import { Analytics } from "@shared"

import TextFieldComponent from "./TextField"

const TextField = Analytics(TextFieldComponent)

export { TextField }
export default TextField
